import { twMerge } from "tailwind-merge";

interface NationalFlag {
  className?: string;
  url: string;
}
export const NationalFlag = ({ url, className }: NationalFlag) => {
  return (
    <div
      className={twMerge(
        "w-[24px] h-[18px] bg-cover bg-no-repeat bg-center border border-[#eee] flex-none ",
        className,
      )}
      style={{ backgroundImage: `url(${url})` }}
    ></div>
  );
};
